var React = require('react');

function IconEdit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M77.9 14.2L30.5 61.6c-.3.3-.6.7-.8 1.2L24.9 78c-.7 2.3 1.4 4.5 3.7 3.7l15.1-4.8.6-.3c.2-.1.5-.3.7-.5l47.4-47.4-14.5-14.5zM40.4 70c1.5 1.5 1 4.1-1 4.8l-6.3 2.5c-2.4 1-4.8-1.4-3.9-3.9l2.5-6.3c.8-2 3.3-2.5 4.8-1l3.9 3.9zM44 57l-1.6-1.6 31.9-31.9 1.6 1.6L44 57z","key":0}),React.createElement("path",{"d":"M84.5 7.7l-4.8 4.8L94.1 27l4.8-4.8c1.1-1.1 1.1-2.9 0-4.1L88.6 7.7c-1.1-1.2-3-1.2-4.1 0z","key":1}),React.createElement("path",{"d":"M73 57.2v21c0 2.7-2.3 4.9-4.9 4.9H12.9c-2.7 0-4.9-2.3-4.9-4.9V23.1c0-2.7 2.3-4.9 4.9-4.9h54.3l6.6-6.6c-1.7-.9-3.7-1.4-5.8-1.4H12.9C5.8 10.2 0 16 0 23.1v55.1c0 7.1 5.8 12.9 12.9 12.9H68c7.1 0 12.9-5.8 12.9-12.9v-29l-7.9 8z","key":2})]);
}

IconEdit.defaultProps = {"className":"icon edit","viewBox":"0 0 100 100"};

module.exports = IconEdit;

IconEdit.default = IconEdit;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-edit.svg
// module id = 525
// module chunks = 0